






import {Vue, Component, Prop} from 'vue-property-decorator';
import {State} from 'vuex-class';
@Component
export default class MemberList extends Vue {
  @Prop() private rowspan!: number;
  @State private view!: object;
}
